/**
 * LinksReportsSocialIcons - Colored 3D social icons (Owner Portal)
 *
 * Purpose:
 *   Renders Instagram, Facebook, and YouTube as colored/3D-style icon links. Used in the
 *   top nav "More" dropdown. Icons open in new tabs; hover: lift + scale + shadow;
 *   focus-visible: outline for accessibility.
 *
 * Scope:
 *   Used only by MoreMenu.jsx in the More dropdown panel.
 *
 * Assets:
 *   Colored 3D SVGs in frontend/src/assets/social3d/ (no hotlinking).
 */
import React from 'react';
import instagramIcon from '../../assets/social3d/instagram.svg';
import facebookIcon from '../../assets/social3d/facebook.svg';
import youtubeIcon from '../../assets/social3d/youtube.svg';

const SOCIAL_LINKS = [
  {
    id: 'instagram',
    href: 'https://www.instagram.com/clcvacationhomes',
    ariaLabel: 'Open Instagram in new tab',
    src: instagramIcon,
  },
  {
    id: 'facebook',
    href: 'https://www.facebook.com/share/1CTbLpqR8d/?mibextid=wwXIfr',
    ariaLabel: 'Open Facebook in new tab',
    src: facebookIcon,
  },
  {
    id: 'youtube',
    href: 'https://www.youtube.com/@clcvacationhomes',
    ariaLabel: 'Open YouTube in new tab',
    src: youtubeIcon,
  },
];

const ICON_SIZE = 32;

const wrapperStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 'var(--spacing-3)',
  flexShrink: 0,
};

const linkStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  borderRadius: 'var(--radius-md, 6px)',
  outline: 'none',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
};

export default function LinksReportsSocialIcons() {
  return (
    <div className="olrp-social-icons" style={wrapperStyle} role="group" aria-label="Social media links">
      {SOCIAL_LINKS.map(({ id, href, ariaLabel, src }) => (
        <a
          key={id}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={ariaLabel}
          className="olrp-social-icon-link"
          style={linkStyle}
        >
          <img src={src} alt="" width={ICON_SIZE} height={ICON_SIZE} decoding="async" />
        </a>
      ))}
    </div>
  );
}
